import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import { emailRegex } from "utils/validation";
import { ReactComponent as AddIcon } from "assets/icons/add-plus.svg";
import DefaultUserOPNG from "assets/icons/default-user.png";
import { ReactComponent as PencilSVG } from "assets/icons/pencil.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { ReactComponent as MergeIcon } from "assets/icons/MergeAccountIcon.svg";
import axios from "axios";
import { Box } from "@material-ui/core";
import {
  HintField,
  InputField,
  LabelField,
  MyCheckbox,
  MyRadioGroup,
  Text,
} from "components";
import getCroppedImg from "components/CropImage";
import AlertDialog from "components/Dialog";
import MainDialog from "components/Dialog/MainDialog";
import FindMyCity from "components/FindMyCity";
import MyModal from "components/MyModal";
import { PhonePicker } from "components/PhonePicker";
import Button from "components/button/Button.jsx";
import HebrewDatePicker from "components/hebrewDatePicker/HebrewDatePicker.jsx";
import { VirtualKeyboard } from "components/keyboard";
import {
  defaultGenderOptions,
  defaultPronounceOptions,
  defaultRelationshipOptions,
  defaultReligionOptions,
  defaultStatusOptions,
  defaultTitleOptions,
} from "constants/memberOptions.constants.js";
import { useFormik } from "formik";
import {
  formatDate,
  getDateFormat,
  getDateFormatForDatePicket,
  maskDate,
} from "helper/dateFormat";
import {
  postalCodeFormat,
  postalCodeLabel,
  stateLabel,
} from "helper/postalCodeFormat";
import { useSearch } from "hook";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ImageUploader from "react-images-upload";
import { isValidPhoneNumber } from "react-phone-number-input";
import { toastr } from "react-redux-toastr";
import { useHistory, useLocation } from "react-router-dom";
import Select, { components } from "react-select";
import MaskedInput from "react-text-mask";
import createAutoCorrectedDatePipe from "text-mask-addons/dist/createAutoCorrectedDatePipe";
import { colors } from "theme";
import { DateFormetContext } from "../../../app/App.js";
import { uploadFile } from "../../Auth/Presigned";
import { AddNewMemberSchema } from "../../ValidationSchema";
import AddRelatedContact from "../addRelatedContact/AddRelatedContact.jsx";
import RelatedContacts from "../relatedContacts/RelatedContacts.jsx";
import CreateYahrzeitAlert from "./CreateYahrzeitModal/CreateYahrzeitAlert";
import { CheckBox, CheckBoxesContainer, CheckBoxWrapper, Label } from "./Theme";
import "./style.scss";
import { MergeFamilyModal } from "./familyMerge/index.js";

const styles = {
  circleButtonBody: {
    background: "#FFFFFF",
    borderRadius: "50%",
    width: 20,
    height: 20,
    right: 0,
    top: 3,
    cursor: "pointer",
  },
  textIconButton: {
    color: colors.primaryColor,
    fontSize: 16,
  },
};

const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  borderColor: "#F3F6F9",
  color: "#3F4254",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",
};
const colourStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
    height: 48,
  }),
};

const ageFromDob = (dob) => {
  if (!dob) return "";
  const birthDate = new Date(dob);
  if (Number.isNaN(birthDate.getTime())) return "";
  const today = new Date();
  let years = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) years--;
  return `${years} Years`;
};

const AddNewMember = ({ user: fromComp, account, refresh, setRefresh }) => {
  const generalOptions = localStorage.getItem("generalOptions")
    ? JSON.parse(localStorage.getItem("generalOptions"))
    : {};
  const getOptions = (key, defaultOptions) => {
    return {
      options: generalOptions?.[key]?.options || defaultOptions || [],
      hidden: generalOptions?.[key]?.hidden || false,
    };
  };

  const relationshipOptions = getOptions(
    "Relationship",
    defaultRelationshipOptions
  );
  const pronounceOptions = getOptions("Pronouns", defaultPronounceOptions);
  const titleOptions = getOptions("Title", defaultTitleOptions);
  const genderOptions = getOptions("Sex", defaultGenderOptions);
  const statusOptions = getOptions("Status", defaultStatusOptions);
  const religionOptions = getOptions("Religion", defaultReligionOptions);

  const dateFormet = React.useContext(DateFormetContext);
  const history = useHistory();
  const { state: user } = useLocation();
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState(null);
  const [selected, setSelected] = useState("Account info");
  const { searchAction } = useSearch({ action: setSearch });
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [openKeyboard, setOpenKeyboard] = useState(false);
  const [open, setOpen] = useState(false);
  const [image, setImage] = useState(DefaultUserOPNG);
  const [imageData, setImageData] = useState("");
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [openCropper, setOpenCropper] = useState(false);
  const [pictures, setPictures] = useState();

  const [rotation, setRotation] = useState(0);
  const [profileImage, setProfileImage] = useState("");
  const [zoom, setZoom] = useState(1);
  const [croppedImage, setCroppedImage] = useState(null);
  const [selectfieldColor, setSelectfieldColor] = useState(true);
  const [placeID, setPlaceID] = useState("");
  const [localFormat, setLocalFormat] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openCreateYahrzeit, setOpenCreateYahrzeit] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  const [startDate, setStartDate] = useState(new Date());

  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);

  const dateMask = maskDate();
  const placeholderFormat = getDateFormat();
  const dateFormate = getDateFormatForDatePicket();
  const [message, setMessage] = useState("");
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [openAddRelatedContact, setOpenAddRelatedContact] = useState(false);
  const [confirmDeleteRelatedContact, setConfirmDeleteRelatedContact] =
    useState({
      open: false,
      index: null,
    });

  const formateRelatedContact = (relatedContact) => {
    return relatedContact?.map((item) => {
      return {
        contact: {
          label: item?.id?.full_name,
          value: item?.id?._id,
          account_id: item?.id?.account_id,
        },
        relationship: {
          label: item?.relationship,
          value: item?.relationship,
        },
      };
    });
  };

  const initialValues = {
    first_name: user?.first_name ? user?.first_name : "",
    middle_name: user?.middle_name ? user?.middle_name : undefined,
    last_name: user?.last_name ? user?.last_name : "",
    unsubscribedEmail: user?.unsubscribedEmail
      ? user?.unsubscribedEmail
      : false,
    unsubscribedText: user?.unsubscribedText ? user?.unsubscribedText : false,

    hebrew_name: user?.hebrew_name ? user?.hebrew_name : "",
    nickname: user?.nickname ? user?.nickname : "",
    email_address: user?.email_address ? user?.email_address : "",
    gender: user?.gender ? user?.gender : "",
    date_of_birth: user?.date_of_birth ? user?.date_of_birth : "",
    anniversary_date: user?.anniversary_date ? user?.anniversary_date : "",
    metva_date: user?.metva_date ? user?.metva_date : "",
    mark_as_desease: user?.mark_as_deceased ? user?.mark_as_deceased : false,
    phone_number: user?.mobile_number ? user?.mobile_number : undefined,
    home_phone: user?.home_phone ? user?.home_phone : "",
    status: user?.social_status ? user?.social_status : "",
    pronounce: user?.pronounce ? user?.pronounce : "",
    state: user?.state ? user?.state : "",
    permission: user?.account_permission ? user?.account_permission : "",
    emergency_contact_name: user?.emergency_contact_name
      ? user?.emergency_contact_name
      : "",
    emergency_contact_number: user?.emergency_contact_number
      ? user?.emergency_contact_number
      : "",
    title: user?.title ? user?.title : "",
    occupation: user?.occupation ? user?.occupation : "",
    religion: user?.religion ? user?.religion : "",
    location: user?.location ? user?.location : "",
    city: user?.city ? user?.city : "",
    addressLine2: user?.addressLine2 ? user?.addressLine2 : "",
    zip_code: user?.zip_code ? user?.zip_code : "",
    profile_img: user?.profile_img ? user?.profile_img : "",
    // relationship: {
    //   id: user?.relationship?.[0],
    //   name: user?.relationship?.[0],
    // },
    relationship: user?.relationship?.[0],
    hebrewDateOfBirth: user?.hebrewDateOfBirth ? user?.hebrewDateOfBirth : {},
    relatedContact:
      user?.relatedContact?.length > 0
        ? formateRelatedContact(user?.relatedContact)
        : [],
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: AddNewMemberSchema,

    onSubmit: async (values) => {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = (await pictures?.length)
        ? await uploadFile(pictures[0], pictures[0], token)
        : "";
      const input = {
        contactID: user?._id,
      };

      if (values.first_name) {
        input.first_name = values.first_name;
      } else {
        input.first_name = " ";
      }
      if (newUrl.fileName) {
        input.profile_img = newUrl.fileName;
      }
      if (values.last_name) {
        input.last_name = values.last_name;
      } else {
        input.last_name = "";
      }
      if (values.nickname) {
        input.nickname = values.nickname;
      } else {
        input.nickname = "";
      }
      if (values.permission) {
        input.account_permission = values.permission;
      }
      if (values.relationship) {
        input.relationship = [values?.relationship ?? " "];
      }
      if (values.middle_name) {
        input.middle_name = values.middle_name;
      } else {
        input.middle_name = "";
      }
      if (values.hebrew_name) {
        input.hebrew_name = values.hebrew_name;
      } else {
        input.hebrew_name = "";
      }
      if (values.email_address) {
        input.email_address = formik.values.email_address;
      } else {
        input.email_address = "";
      }
      if (values.gender) {
        input.gender = values.gender;
      }
      if (values.date_of_birth) {
        input.date_of_birth = values.date_of_birth;
      }
      if (values.date_of_birth === "") {
        input.date_of_birth = "";
      }
      if (values.date_of_birth === null) {
        input.date_of_birth = null;
      }
      if (values.phone_number) {
        input.mobile_number = values.phone_number;
      } else {
        input.mobile_number = "";
      }
      if (values.home_phone) {
        input.home_phone = values.home_phone;
      } else {
        input.home_phone = "";
      }
      if (values.emergency_contact_name) {
        input.emergency_contact_name = values.emergency_contact_name;
      } else {
        input.emergency_contact_name = "";
      }
      if (values.emergency_contact_number) {
        input.emergency_contact_number = values.emergency_contact_number;
      } else {
        input.emergency_contact_number = "";
      }
      if (values.title) {
        input.title = values.title;
      } else {
        input.title = "";
      }
      if (values.pronounce) {
        input.pronounce = values.pronounce;
      } else {
        input.pronounce = "";
      }
      if (values.occupation) {
        input.occupation = values.occupation;
      } else {
        input.occupation = "";
      }
      if (values.religion) {
        input.religion = values.religion;
      } else {
        input.religion = "";
      }
      if (values.city) {
        input.city = values.city;
      } else {
        input.city = "";
      }
      if (values.location) {
        input.location = values.location;
      } else {
        input.location = "";
      }
      if (values.zip_code || !values.zip_code) {
        input.zip_code = values.zip_code;
      } else {
        input.zip_code = "";
      }
      if (values.status) {
        input.social_status = values.status;
      } else {
        input.social_status = "";
      }
      if (values.state) {
        input.state = values.state;
      } else {
        input.state = "";
      }
      if (values.metva_date) {
        input.metva_date = values.metva_date;
      }
      if (values.metva_date === "") {
        input.metva_date = "";
      }
      if (values.anniversary_date) {
        input.anniversary_date = values.anniversary_date;
      }
      if (values.anniversary_date === "") {
        input.anniversary_date = "";
      }
      if (
        formik?.values.email_address &&
        !emailRegex.test(
          formik?.values.email_address
        )
      ) {
        toastr.info("Validation", "You have entered an invalid email address!");
      }
      if (
        (formik?.values.email_address &&
          emailRegex.test(
            formik?.values.email_address
          )) ||
        !formik?.values.email_address
      ) {
        enableLoading(true);
        await AuthService.updateAccount(input, token)
          .then((res) => {
            toastr.success("Success", "Success");

            if (res) {
              get_contact();
            }
          })
          .catch((err) => {
            enableLoading(false);
            toastr.error("Error", err?.data?.message);
          });
      }
      if (values.hebrewDateOfBirth?.date) {
        input.hebrewDateOfBirth = values.hebrewDateOfBirth;
      } else {
        input.hebrewDateOfBirth = {};
      }
    },
  });

  const autoCorrectedDatePipe = createAutoCorrectedDatePipe(
    dateFormate || "mm/dd/yyyy"
  );

  const handleDeceasedCheck = () => {
    if (
      formik.values?.deceasedInput === "DECEASED" ||
      formik.values?.deceasedInput === "deceased"
    ) {
      setOpenModal(false);
      formik.setFieldValue(`mark_as_desease`, true);
    } else {
      toastr.error("Error", "Invalid Value");
    }
  };

  const handleDOB = (value) => {
    if (value <= moment().format("YYYY-MM-DD")) {
      formik.setFieldValue(`date_of_birth`, value);
    } else {
      alert("You cann't select future date.");
    }
  };

  const handleSubscribeChange = (key, e) => {
    setConfirmDialog({ key: key, value: true });
  };

  const communicationCheckboxesList = [
    {
      id: "unsubscribedEmail",
      label: formik?.values?.unsubscribedEmail
        ? "Email Unsubscribed "
        : "Email Unsubscribe ",
      value: formik?.values?.unsubscribedEmail,
      onChange: (e) => {
        handleSubscribeChange("unsubscribedEmail", e);
      },
      date: user?.unsubscribedDateEmail,
    },
    {
      id: "hideEmail",
      label: formik?.values?.unsubscribedText
        ? "Text unsubscribed "
        : "Text unsubscribe ",
      value: formik?.values?.unsubscribedText,
      onChange: (e) => {
        handleSubscribeChange("unsubscribedText", e);
      },
      date: user?.unsubscribedDateText,
    },
  ];

  const checkTime = (startDate) => {
    let localTime = startDate.getTime();
    let localOffset = startDate.getTimezoneOffset() * 60000;

    // obtain UTC time in msec
    let utc = localTime + localOffset;
    // create new Date object for different city
    // using supplied offset
    // var nd = new Date(utc + 3600000 * offset);
    //nd = 3600000 + nd;
    utc = new Date(utc);

    setStartDate(moment(utc)?.format("YYYY/MM/DD"));

    // return moment(utc)?.format("YYYY/MM/DD");
  };

  const enableLoading = (value) => {
    setLoading(value);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const onCropComplete = async (croppedArea, croppedAreaPixels) => {
    const croppedImage = await getCroppedImg(
      image,
      croppedAreaPixels,
      rotation
    );
    setCroppedImage(croppedImage);
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }
  useEffect(() => {
    if (history?.location?.state?.activeTab) {
      setUsers(null);
      setSelected(history?.location?.state?.activeTab);
      return;
    } else if (
      (history?.location?.state == undefined ||
        history?.location?.state == null) &&
      selected === "Details"
    ) {
      setSelected("Family");
    }

    setUsers(history?.location?.state ? history?.location?.state : null);
  }, [history?.location?.state]);
  useEffect(() => {
    setImage(user?.profile_img ? user?.profile_img : DefaultUserOPNG);
  }, [user]);
  useEffect(() => {
    setProfileImage(users?.profile_img ? users?.profile_img : DefaultUserOPNG);
  }, [users]);

  const closeAllModal = async () => {
    setOpenCropper(false);
    setOpen(false);

    formik.setFieldValue && formik.setFieldValue("profile_img", croppedImage);
  };

  const handleChange = async (e) => {
    if (e.target.files.length) {
      if (e.target.files[0]?.name) setImageData(e.target.files[0]);
      let imageDataUrl = await readFile(e.target.files[0]);
      setImage(imageDataUrl);
      setTimeout(() => {
        setOpenCropper(true);
      }, 1000);
    }
  };

  const get_contact = async () => {
    const token = await getAccessTokenSilently();
    await AuthService.getContactById(user?._id, token)
      .then((res) => {
        setRefresh(!refresh);
        history.push(`/member-details/${user?._id}/family-member`, res[0]);

        // if (res[0]?.profile_img) setImage(res[0]?.profile_img);
        enableLoading(false);
      })
      .catch((err) => {
        enableLoading(false);
        toastr.error("Error", err?.data?.message);
      });
  };
  const onDrop = async (pictureFiles, pictureDataURLs) => {
    setPictures(pictureFiles);
    let imageDataUrl = await readFile(pictureFiles[0]);
    // setProfileImage(imageDataUrl);
    setProfileImage(imageDataUrl);

    localStorage.setItem("memberProfileIMG", JSON.stringify(imageDataUrl));
  };

  const ProfileImage = JSON.parse(localStorage.getItem("memberProfileIMG"));
  const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;

  // function to uniform date
  const uniformDate = (date) => {
    if (date) {
      let newDate = new Date(date);
      let newDate2 = new Date(
        newDate.getTime() + newDate.getTimezoneOffset() * 60000
      );
      return newDate2;
    }
  };

  let myVAlues = formik?.values;
  const saveMember = async (myVAlues) => {
    const token = await getAccessTokenSilently();
    const newUrl = (await pictures?.length)
      ? await uploadFile(pictures[0], pictures[0], token)
      : "";

    const input = {
      contactID: user?._id,
      unsubscribedEmail: formik?.values.unsubscribedEmail || false,
      unsubscribedText: formik?.values.unsubscribedText || false,
      relatedContact: formik?.values.relatedContact?.map((item) => {
        return {
          id: item?.contact?.value,
          relationship: item?.relationship?.value,
        };
      }),
    };

    if (formik?.values.first_name) {
      input.first_name = formik?.values.first_name;
    } else {
      input.first_name = " ";
    }

    if (formik?.values.addressLine2) {
      input.addressLine2 = formik?.values.addressLine2;
    } else {
      input.addressLine2 = " ";
    }
    if (newUrl.fileName) {
      input.profile_img = newUrl.fileName;
    }
    if (formik?.values.last_name) {
      input.last_name = formik?.values.last_name;
    } else {
      input.last_name = "";
    }
    if (formik?.values.nickname) {
      input.nickname = formik?.values.nickname;
    } else {
      input.nickname = "";
    }

    if (formik?.values.permission) {
      input.account_permission = formik?.values.permission;
    }
    if (formik?.values.relationship) {
      input.relationship = [formik?.values?.relationship ?? " "];
    } else {
      input.relationship = [];
    }
    if (formik?.values.middle_name) {
      input.middle_name = formik?.values.middle_name;
    } else {
      input.middle_name = "";
    }
    if (formik?.values.hebrew_name) {
      input.hebrew_name = formik?.values.hebrew_name;
    } else {
      input.hebrew_name = "";
    }
    if (formik?.values.email_address) {
      input.email_address = formik?.values.email_address;
    } else {
      input.email_address = "";
    }
    if (formik?.values.gender) {
      input.gender = formik?.values.gender;
    } else {
      input.gender = "";
    }
    if (formik?.values.date_of_birth) {
      input.date_of_birth = formik?.values.date_of_birth;
    }
    if (formik?.values.date_of_birth === "") {
      input.date_of_birth = "";
    }
    if (formik?.values.date_of_birth === null) {
      input.date_of_birth = null;
    }
    if (formik?.values.phone_number) {
      input.mobile_number = formik?.values.phone_number;
    } else {
      input.mobile_number = "";
    }
    if (formik?.values.home_phone) {
      input.home_phone = formik?.values.home_phone;
    } else {
      input.home_phone = "";
    }
    if (formik?.values.emergency_contact_name) {
      input.emergency_contact_name = formik?.values.emergency_contact_name;
    } else {
      input.emergency_contact_name = "";
    }
    if (formik?.values.emergency_contact_number) {
      input.emergency_contact_number = formik?.values.emergency_contact_number;
    } else {
      input.emergency_contact_number = "";
    }
    if (formik?.values.title) {
      input.title = formik?.values.title;
    } else {
      input.title = "";
    }
    if (formik?.values.pronounce) {
      input.pronounce = formik?.values.pronounce;
    } else {
      input.pronounce = "";
    }
    if (formik?.values.occupation) {
      input.occupation = formik?.values.occupation;
    } else {
      input.occupation = "";
    }
    if (formik?.values.religion) {
      input.religion = formik?.values.religion;
    } else {
      input.religion = "";
    }
    if (formik?.values.city) {
      input.city = formik?.values.city;
    } else {
      input.city = "";
    }
    if (formik?.values.location) {
      input.location = formik?.values.location;
    } else {
      input.location = "";
    }
    if (formik?.values.zip_code) {
      input.zip_code = formik?.values.zip_code;
    }
    if (formik?.values.status) {
      input.social_status = formik?.values.status;
    } else {
      input.social_status = "";
    }
    if (formik?.values.state) {
      input.state = formik?.values.state;
    } else {
      input.state = "";
    }
    if (formik?.values.metva_date) {
      input.metva_date = formik?.values.metva_date;
    }
    if (formik?.values.metva_date === "") {
      input.metva_date = "";
    }
    if (formik?.values.metva_date === null) {
      input.metva_date = null;
    }
    //
    if (formik?.values?.mark_as_desease) {
      input.mark_as_deceased = formik?.values?.mark_as_desease;
    }
    if (formik?.values?.mark_as_desease === false) {
      input.mark_as_deceased = false;
    }
    // if(mark_as_desease)
    if (formik?.values.anniversary_date) {
      input.anniversary_date = formik?.values.anniversary_date;
    }
    if (formik?.values.anniversary_date === "") {
      input.anniversary_date = "";
    }
    if (formik?.values.anniversary_date === null) {
      input.anniversary_date = null;
    }
    if (
      formik?.values.email_address &&
      !emailRegex.test(
        formik?.values.email_address
      )
    ) {
      toastr.info("Validation", "You have entered an invalid email address!");
    }

    if (formik?.values.hebrewDateOfBirth?.date) {
      input.hebrewDateOfBirth = formik?.values.hebrewDateOfBirth;
    } else {
      input.hebrewDateOfBirth = {};
    }

    const validMobilePhone = isValidPhoneNumber(input.mobile_number || "");
    if (input.mobile_number && !validMobilePhone) {
      toastr.info("Validation", "Invalid Mobile phone");
    }
    const validHomePhone = isValidPhoneNumber(input.home_phone || "");
    if (input.home_phone && !validHomePhone) {
      toastr.info("Validation", "Invalid Home phone");
    }
    const validEmergencyPhone = isValidPhoneNumber(
      input.emergency_contact_number || ""
    );
    if (input.emergency_contact_number && !validEmergencyPhone) {
      toastr.info("Validation", "Invalid Emergency contact number");
    }
    const validZipCode = postalCodeFormat(input.zip_code || "");
    if (input.zip_code && !validZipCode) {
      toastr.info("Validation", `Invalid ${postalCodeLabel()}`);
    }

    // enableLoading(true);
    await AuthService.updateAccount(input, token)
      .then((res) => {
        toastr.success("Success", "Success");

        if (res) {
          if (res?.mark_as_deceased) {
            setOpenCreateYahrzeit(true);
          } else {
            get_contact();
          }
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message);
        enableLoading(false);
      });
  };

  const validateHebrew = (evt) => {
    var theEvent = evt || window.event;

    // Handle paste
    if (theEvent.type === "paste") {
      key = theEvent.clipboardData.getData("text/plain");
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /^[\u0590-\u05fe]+|[\b]+$/i;

    if (
      !regex.test(key) &&
      theEvent.keyCode !== 37 &&
      theEvent.keyCode !== 39
    ) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  };
  const addressHandleChange = (address) => {
    formik.setFieldValue("location", {
      formattedAddress: (address?.label).split(",")[0],
      place_id: address?.value?.place_id || null,
    });
    setPlaceID(address?.value?.place_id);
    if (!address?.value?.place_id) {
      formik.setFieldValue("zip_code", "");
      formik.setFieldValue("state", "");
      formik.setFieldValue("city", "");
    } else {
      if (address?.value?.terms.length === 3) {
        formik.setFieldValue("state", address?.value?.terms[3]?.value);
        formik.setFieldValue("city", address?.value?.terms[1]?.value);
      } else {
        formik.setFieldValue("state", address?.value?.terms[3]?.value);
        formik.setFieldValue("city", address?.value?.terms[2]?.value);
      }
    }
  };
  const getZipCode = async () => {
    if (placeID) {
      const result = await axios(
        `https://maps.googleapis.com/maps/api/geocode/json?place_id=${placeID}&key=AIzaSyCAt0TjvU_m8ufUMYn2EXi9mteHSOUB7uA`
      );
      let data = result.data.results[0].address_components?.filter(
        (item) => item.types[0] == "postal_code"
      );

      if (data?.length === 0) return;
      formik.setFieldValue("zip_code", data?.[0]?.short_name);

      // let data = result.data.results[0].address_components.map((item) => {
      //   if (item.types[0] == "postal_code") {
      //     // formik.setFieldValue("zip_code", item.short_name);
      //     return item;
      //   }
      //   // if (item.types[0] !== "postal_code") {
      //   //   formik.setFieldValue("zip_code", "0000");
      //   // }
      // });
    }
  };

  useEffect(() => {
    if (!placeID) return;
    getZipCode();
  }, [placeID]);

  // useEffect(() => {
  //   if (formik?.values?.mark_as_desease === true) {
  //     setOpenModal(true);
  //   }
  // }, [formik?.values?.mark_as_desease]);
  function convertUTCToLocalDate(date) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate()
    );
    return date;
  }

  function convertLocalToUTCDate(date, name) {
    if (!date) {
      return date;
    }
    date = new Date(date);
    date = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );
    formik.setFieldValue(name, date);
    return date;
  }

  const checkCanCopyAddress = () => {
    const address = formik?.values?.location?.formattedAddress || "";
    const { addressLine2, city, state, zip_code } = formik?.values;
    const valid =
      address?.trim().length ||
      addressLine2?.trim().length ||
      city?.trim().length ||
      state?.trim().length ||
      zip_code?.trim().length;
    return valid;
  };

  const copyAddressHandler = () => {
    if (!checkCanCopyAddress()) return;
    const address = formik?.values?.location?.formattedAddress || "";
    const { addressLine2, city, state, zip_code } = formik?.values;
    const copyAddress =
      address +
      " " +
      addressLine2 +
      " " +
      city +
      (city && state ? ", " : "") +
      state +
      " " +
      zip_code;
    navigator.clipboard.writeText(copyAddress);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 2000);
  };

  const displaySubscribeDialogMsg = (key) => {
    const emailText = formik?.values?.unsubscribedEmail
      ? "Re-Subscribe"
      : "Unsubscribe";
    const textText = formik?.values?.unsubscribedText
      ? "Re-Subscribe"
      : "Unsubscribe";
    return `Do you want to ${
      key === "unsubscribedEmail" ? emailText : textText
    } this person?`;
  };

  const closeCreateYahrzeitAlert = () => {
    setOpenCreateYahrzeit(false);
    get_contact();
  };

  const openAddRelatedContactHandler = () => {
    setOpenAddRelatedContact(true);
  };

  const closeAddRelatedContactHandler = () => {
    setOpenAddRelatedContact(false);
  };

  const addRelatedContactHandler = (values) => {
    if (!values?.contact || !values?.relationship) {
      toastr.info("Validation", "Please select contact and relationship");
      return;
    }
    formik.setFieldValue("relatedContact", [
      ...formik.values.relatedContact,
      {
        contact: values?.contact,
        relationship: values?.relationship,
      },
    ]);
    closeAddRelatedContactHandler();
  };

  const onDeleteRelatedContact = (index) => {
    setConfirmDeleteRelatedContact((prev) => ({
      ...prev,
      open: true,
      index,
    }));
  };

  const closeConfirmDeleteRelatedContact = () => {
    setConfirmDeleteRelatedContact((prev) => ({
      ...prev,
      open: false,
      index: null,
    }));
  };

  const deleteRelatedContactHandler = (index) => {
    let relatedContact = [...formik.values.relatedContact];
    relatedContact.splice(index, 1);
    formik.setFieldValue("relatedContact", relatedContact);
    closeConfirmDeleteRelatedContact();
  };

  return (
    <>
      <div className="first-time w-100">
        <Card className="card card-custom pl-8 my-10">
          <div className="login-form login-signin">
            <form
              onSubmit={formik.handleSubmit}
              className="form fv-plugins-bootstrap fv-plugins-framework"
            >
              <div className="py-8 d-flex" style={{ alignItems: "center" }}>
                <LabelField title="Account permission" className="mb-0" />
                <MyRadioGroup
                  row
                  // disabled={account?.main_contact?._id === user?._id}
                  handleChange={(val) =>
                    formik.setFieldValue &&
                    formik.setFieldValue("permission", val.target.value)
                  }
                  value={formik.values.permission}
                  name="permission"
                  className="ml-5"
                  formsControls={[
                    { value: "family_member", label: "Member" },
                    { value: "admin", label: "Admin" },
                  ]}
                />
              </div>
              <div className="sub-title">
                <Text style={styles.textIconButton}>General info</Text>
                <hr />
              </div>
              <div className="">
                <div
                  className="d-flex w-50 justify-content-between"
                  style={{ paddingRight: "14%" }}
                >
                  <div className="pb-10">
                    <LabelField title="Profile Image" />
                    <div className="position-relative d-inline-block">
                      <div
                        className={
                          image !== DefaultUserOPNG
                            ? "image-container ml-0"
                            : undefined
                        }
                      >
                        <img
                          alt="profile IMG"
                          src={profileImage ?? DefaultUserOPNG}
                          style={{ objectFit: "fill" }}
                          height="120"
                          width="120"
                          className={
                            image !== DefaultUserOPNG ? "image" : undefined
                          }
                          name="profile_img"
                        />
                      </div>
                      <div
                        className="shadow text-center justify-content-center align-items-center position-absolute"
                        style={{
                          ...styles.circleButtonBody,
                          right: image !== DefaultUserOPNG ? -7 : -24,
                        }}
                        onClick={handleOpen}
                      >
                        <PencilSVG />
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <Text style={{ color: "#B5B5C3", fontSize: 12 }}>
                        Allowed file types: png, jpg, jpeg.
                      </Text>
                    </div>
                    {formik.touched["profile_img"] &&
                    formik.errors["profile_img"] ? (
                      <HintField
                        error={formik.errors["profile_img"]}
                        className="col-sm-12"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <Row>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "First Name",
                      name: "first_name",
                      placeholder: "First name",
                      checkValidation: true,
                      value: formik.values?.first_name,
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "Middle Name",
                      name: "middle_name",
                      placeholder: "Middle name",
                      value: formik.values?.middle_name,
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "Last Name",
                      name: "last_name",
                      placeholder: "Last name",
                      checkValidation: true,
                      value: formik.values?.last_name,
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  {openKeyboard && (
                    <VirtualKeyboard
                      handleChange={(e) =>
                        formik.setFieldValue("hebrew_name", e)
                      }
                      setOpenKeyboard={setOpenKeyboard}
                      value={
                        formik.values?.hebrew_name
                          ? formik.values?.hebrew_name
                          : ""
                      }
                    />
                  )}
                  <InputField
                    setOpenKeyboard={setOpenKeyboard}
                    openKeyboard={openKeyboard}
                    {...{
                      formik,
                      title: "Hebrew Name",
                      name: "hebrew_name",
                      placeholder: "Click on icon to type",
                      value: formik.values?.hebrew_name
                        ? formik.values?.hebrew_name
                        : "",
                    }}
                    // onKeyDown={validateHebrew}
                    handleChange={(e) => {
                      formik.setFieldValue("hebrew_name", e.target.value);
                    }}
                  />
                </Col>
              </Row>
              <Row className="mt-5">
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "Nickname",
                      name: "nickname",
                      placeholder: "Nickname",
                      checkValidation: true,
                      value: formik.values?.nickname,
                    }}
                  />
                </Col>
              </Row>

              <Row className="mt-5">
                {!titleOptions?.hidden && (
                  <Col className="col-sm-3">
                    <LabelField title={"Title"} />
                    <Select
                      {...{
                        formik,
                        title: "Title",
                        name: `title`,
                        mandatory: false,
                      }}
                      isClearable={formik.values.title ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={titleOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("title", "");
                          return;
                        }
                        formik.setFieldValue(`title`, value.value);
                      }}
                      value={
                        formik.values.title
                          ? {
                              label: formik.values.title,
                              value: formik.values.title,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
                {!genderOptions?.hidden && (
                  <Col className="col-sm-3">
                    <LabelField title={"Sex"} />
                    <Select
                      {...{
                        formik,
                        title: "Sex",
                        name: `gender`,
                        mandatory: false,
                      }}
                      isClearable={formik.values.gender ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={genderOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("gender", "");
                          return;
                        }
                        formik.setFieldValue(`gender`, value.value);
                      }}
                      value={
                        formik.values.gender
                          ? {
                              label: formik.values.gender,
                              value: formik.values.gender,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
                {!pronounceOptions?.hidden && (
                  <Col className="col-sm-3">
                    <LabelField title={"Pronouns"} />
                    <Select
                      {...{
                        formik,
                        title: "Pronouns",
                        name: `pronounce`,
                        mandatory: false,
                      }}
                      isClearable={formik?.values?.pronounce ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={pronounceOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("pronounce", "");
                          return;
                        }
                        formik.setFieldValue(`pronounce`, value.value);
                      }}
                      value={
                        formik?.values?.pronounce
                          ? {
                              label: formik?.values?.pronounce,
                              value: formik?.values?.pronounce,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
                {!statusOptions?.hidden && (
                  <Col className="col-sm-3">
                    <LabelField title={"Status"} />
                    <Select
                      {...{
                        formik,
                        title: "Status",
                        name: `status`,
                        mandatory: false,
                      }}
                      isClearable={formik.values.status ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={statusOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("status", "");
                          return;
                        }
                        formik.setFieldValue(`status`, value.value);
                      }}
                      value={
                        formik.values.status
                          ? {
                              label: formik.values.status,
                              value: formik.values.status,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
              </Row>
              <div className="sub-title">
                <Text style={styles.textIconButton}>Contact info</Text>
                <hr />
              </div>
              <Row>
                <Col className="col-sm-3">
                  <LabelField title={"Mobile Phone"} />
                  <PhonePicker
                    value={formik.values.phone_number}
                    handleChange={(e) => {
                      formik.setFieldValue("phone_number", e);
                    }}
                    placeholder="Mobile Phone"
                    copy={true}
                  />
                </Col>
                <Col className="col-sm-3">
                  <LabelField title={"Home Phone"} />
                  <PhonePicker
                    value={formik.values.home_phone}
                    handleChange={(e) => {
                      formik.setFieldValue("home_phone", e);
                    }}
                    placeholder="Home Phone"
                    copy={true}
                  />
                </Col>
                <Col className="col-sm-3">
                  <InputField
                    type="text"
                    {...{
                      formik,
                      title: "Emergency Contact Name",
                      name: "emergency_contact_name",
                      placeholder: "Emergency Contact Name",
                      checkValidation: !!formik.values.emergency_contact_name,
                      value: formik.values?.emergency_contact_name,
                    }}
                    handleChange={(e) => {
                      formik.setFieldValue(
                        "emergency_contact_name",
                        e.target.value
                      );
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  <LabelField title={"Emergency contact number"} />
                  <PhonePicker
                    value={formik.values.emergency_contact_number}
                    handleChange={(e) => {
                      formik.setFieldValue("emergency_contact_number", e);
                    }}
                    placeholder="Emergency contact number"
                    copy={true}
                  />
                </Col>
              </Row>

              <Row className="mt-5 mb-5">
                <Col className="col-sm-3">
                  <InputField
                    type="email"
                    {...{
                      formik,
                      title: "Email Address",
                      name: "email_address",
                      placeholder: "abc@xyz.com",
                      checkValidation: !!formik.values.email_address,
                      value: formik.values?.email_address,
                    }}
                    handleChange={(e) => {
                      formik.setFieldValue("email_address", e.target.value);
                    }}
                    copy={true}
                  />
                </Col>
                <Col className="col-sm-3">
                  <FindMyCity
                    handleChange={addressHandleChange}
                    title="Address"
                    value={
                      formik.values?.location?.formattedAddress
                        ? {
                            label: (formik.values?.location.formattedAddress).split(",")[0],
                            value: `${formik.values?.location?.place_id}`,
                          }
                        : null
                    }
                    inputLike
                    copy={true}
                    isCopied={isCopied}
                    labelCopy={checkCanCopyAddress()}
                    copyAddressHandler={copyAddressHandler}
                    saveNewAddress={true}
                  />
                </Col>
                <Col className="col-sm-3 ">
                  <InputField
                    {...{
                      formik,
                      title: "Address line 2 (Optional)",
                      name: `addressLine2`,
                      placeholder: "Apt, suite, unit, floor, company",
                      value: formik.values?.addressLine2,
                      copy: true,
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "City",
                      name: "city",
                      placeholder: "Enter City",
                      value: formik.values?.city,
                      copy: true,
                    }}
                  />
                </Col>
                <Col className="col-sm-3 mt-5">
                  <InputField
                    {...{
                      formik,
                      title: stateLabel(),
                      name: "state",
                      placeholder: "NY",
                      checkValidation: true,
                      value: formik.values?.state,
                      copy: true,
                    }}
                  />
                </Col>
                <Col className="col-sm-3 mt-5">
                  <InputField
                    {...{
                      formik,
                      title: postalCodeLabel(),
                      name: "zip_code",
                      placeholder: postalCodeLabel(),
                      value: formik.values?.zip_code,
                      copy: true,
                    }}
                    handleChange={(event) => {
                      formik.setFieldValue(`zip_code`, event.target.value);
                    }}
                  />
                </Col>
              </Row>
              {/* Additional info */}
              <div className="sub-title">
                <Text style={styles.textIconButton}>Additional info</Text>
                <hr />
              </div>
              <Row>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "Occupation",
                      name: "occupation",
                      placeholder: "Occupation",
                      value: formik.values?.occupation,
                    }}
                  />
                </Col>
                {!religionOptions?.hidden && (
                  <Col className="col-sm-3">
                    <LabelField title={"Religion"} />
                    <Select
                      {...{
                        formik,
                        title: "Religion",
                        name: `religion`,
                        mandatory: false,
                      }}
                      isClearable={formik.values.religion ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={religionOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("religion", "");
                          return;
                        }
                        formik.setFieldValue(`religion`, value.value);
                      }}
                      value={
                        formik.values.religion
                          ? {
                              label: formik.values.religion,
                              value: formik.values.religion,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
                {!relationshipOptions?.hidden && (
                  <Col
                    className="col-sm-3"
                    style={{
                      zIndex: "auto",
                    }}
                  >
                    <LabelField title={"Relationship"} />
                    <Select
                      {...{
                        formik,
                        title: "Relationship",
                        name: `relationship`,
                        mandatory: false,
                      }}
                      isClearable={formik.values.relationship ?? false}
                      onInputChange={(text) => searchAction(text)}
                      classNamePrefix="react-select"
                      formatOptionLabel={formatOptionLabel}
                      options={relationshipOptions?.options}
                      isLoading={loading}
                      styles={colourStyles}
                      onChange={(value) => {
                        if (!value) {
                          formik.setFieldValue("relationship", "");
                          return;
                        }
                        formik.setFieldValue(`relationship`, value.value);
                      }}
                      value={
                        formik.values.relationship
                          ? {
                              label: formik.values.relationship,
                              value: formik.values.relationship,
                            }
                          : null
                      }
                      components={{ DropdownIndicator }}
                    />
                  </Col>
                )}
              </Row>

              <div className="sub-title mt-10">
                <Text style={styles.textIconButton}>Life cycle events</Text>
                <hr />
              </div>
              <Row>
                <Col className="col-sm-3">
                  <LabelField title={"Date of Birth"} />
                  <DatePicker
                    isClearable
                    showIcon
                    placeholderText={placeholderFormat}
                    dateFormat={dateFormate}
                    disabled={
                      formik?.values?.mark_as_desease
                        ? formik?.values?.mark_as_desease
                        : false
                    }
                    selected={
                      formik?.values?.date_of_birth &&
                      // new Date(formik?.values?.date_of_birth)
                      convertUTCToLocalDate(formik?.values?.date_of_birth)
                    }
                    maxDate={new Date()}
                    onChange={(e) => {
                      formik.setFieldValue(`date_of_birth`, e);
                      convertLocalToUTCDate(e, "date_of_birth");
                    }}
                    customInput={
                      <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={dateMask}
                        keepCharPositions={true}
                        guide={true}
                      />
                    }
                  />
                </Col>
                <Col className="col-sm-3">
                  <InputField
                    {...{
                      formik,
                      title: "Age",
                      name: "age",
                      placeholder: "Age",
                      // type: "number",
                      disabled: true,
                      value: ageFromDob(formik?.values?.date_of_birth),
                    }}
                  />
                </Col>
                <Col className="col-sm-3">
                  <LabelField title={"Anniversary"} />
                  <DatePicker
                    isClearable
                    showIcon
                    placeholderText={placeholderFormat}
                    dateFormat={dateFormate}
                    selected={
                      formik?.values?.anniversary_date &&
                      // new Date(formik?.values?.anniversary_date)
                      convertUTCToLocalDate(formik?.values?.anniversary_date)
                    }
                    onChange={(e) => {
                      formik.setFieldValue(`anniversary_date`, e);
                      convertLocalToUTCDate(e, "anniversary_date");
                    }}
                    customInput={
                      <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={dateMask}
                        keepCharPositions={true}
                        guide={true}
                      />
                    }
                  />
                  {/* <DatePickerField
                    {...{
                      formik,
                      title: "Anniversary",
                      name: "anniversary_date",
                      checkValidation: !!formik.values.anniversary_date,
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(`anniversary_date`, e.target.value);
                      setLocalFormat(true);
                    }}
                    value={
                      formik?.values?.anniversary_date
                        ? formik?.values?.anniversary_date
                        : ""
                    }
                    localFormat={localFormat}
                  /> */}
                </Col>
                <Col className="col-sm-3">
                  <LabelField title={"Bar/Bat Mitzvah"} />
                  <DatePicker
                    isClearable
                    showIcon
                    placeholderText={placeholderFormat}
                    dateFormat={dateFormate}
                    selected={
                      formik?.values?.metva_date &&
                      // new Date(formik?.values?.metva_date)
                      convertUTCToLocalDate(formik?.values?.metva_date)
                    }
                    onChange={(e) => {
                      formik.setFieldValue(`metva_date`, e);
                      convertLocalToUTCDate(e, "metva_date");
                    }}
                    customInput={
                      <MaskedInput
                        pipe={autoCorrectedDatePipe}
                        mask={dateMask}
                        keepCharPositions={true}
                        guide={true}
                      />
                    }
                  />
                  {/* <DatePickerField
                    {...{
                      formik,
                      title: "Bar/Bat Mitzvah",
                      name: "metva_date",
                      checkValidation: !!formik.values.metva_date,
                    }}
                    onChange={(e) => {
                      formik.setFieldValue(`metva_date`, e.target.value);
                      setLocalFormat(true);
                    }}
                    value={
                      formik?.values?.metva_date
                        ? formik?.values?.metva_date
                        : ""
                    }
                    localFormat={localFormat}
                  /> */}
                </Col>
              </Row>
              <Row className="mt-5">
                <Col className="col-sm-3">
                  <LabelField title={"Hebrew birthdate"} />
                  <HebrewDatePicker
                    value={formik.values.hebrewDateOfBirth}
                    onChange={(date) =>
                      formik.setFieldValue("hebrewDateOfBirth", date)
                    }
                  />
                </Col>
              </Row>
              <Row>
                <Col
                  className="col-sm-3"
                  style={{
                    marginTop: "3rem",
                  }}
                >
                  <MyCheckbox
                    title="Mark as Deceased"
                    onChange={(e) => {
                      formik.setFieldValue(
                        `mark_as_desease`,
                        formik?.values?.mark_as_desease === true
                          ? false
                          : e.target.checked
                      );
                      formik.setFieldValue(`deceasedInput`, "");
                      setOpenModal(
                        formik?.values?.mark_as_desease === true ? false : true
                      );
                    }}
                    checked={
                      formik?.values?.mark_as_desease
                        ? formik?.values?.mark_as_desease
                        : false
                    }
                  />
                </Col>
              </Row>

              <div className="sub-title mt-10">
                <Text style={styles.textIconButton}>Related Contacts</Text>
                <hr />
              </div>
              <RelatedContacts
                list={formik?.values?.relatedContact}
                onDeleteRelatedContact={onDeleteRelatedContact}
              />
              <div className="sub-title mt-5">
                <hr />
              </div>
              <div
                className="add-new-payment-info col my-4"
                onClick={openAddRelatedContactHandler}
              >
                <span className="add-icon">
                  <AddIcon />
                </span>
                <span className="add">Add Related Contact</span>
              </div>

              <div className="sub-title mt-10">
                <Text style={styles.textIconButton}>
                  Communication preferences
                </Text>
                <hr />
              </div>
              <CheckBoxesContainer>
                {communicationCheckboxesList?.map((checkbox) => (
                  <CheckBoxWrapper>
                    <CheckBox key={checkbox?.id}>
                      <label className="check-box-container">
                        <input
                          type="checkbox"
                          checked={checkbox?.value}
                          onChange={checkbox?.onChange}
                        />
                        <span className="checkbox-checkmark"></span>
                      </label>
                      <Label>{checkbox?.label}</Label>
                    </CheckBox>
                    {checkbox?.value && checkbox?.date && (
                      <Label>
                        {" "}
                        {`On ${formatDate({
                          date: checkbox?.date,
                          formatType: "defaultWithUTC",
                        })}`}
                      </Label>
                    )}
                  </CheckBoxWrapper>
                ))}
              </CheckBoxesContainer>

              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ my: 3 }}
              >
                <Box>
                  <Button
                    onClick={() => setIsOpenMergePopUp(true)}
                    variant="secondary-light"
                    size="md"
                    style={{ minWidth: "100px" }}
                  >
                    <MergeIcon />
                    <span>Merge</span>
                  </Button>
                </Box>
                <Box display="flex" alignItems="center">
                  <Button
                    onClick={() => history.push("/members")}
                    variant="primary-outline"
                    size="md"
                    style={{ minWidth: "100px" }}
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    onClick={saveMember}
                    className={`ml-5`}
                    variant="primary"
                    size="md"
                    style={{ minWidth: "100px" }}
                  >
                    <span>Save</span>
                    {loading ? (
                      <span className="ml-3 spinner spinner-white"></span>
                    ) : (
                      ""
                    )}
                  </Button>
                </Box>
              </Box>
            </form>
          </div>
        </Card>
      </div>
      <MainDialog
        open={openModal}
        handleClose={() => {
          setOpenModal(false);
          formik.setFieldValue(`mark_as_desease`, false);
        }}
        onDecline={() => {
          setOpenModal(false);
          formik.setFieldValue(`mark_as_desease`, false);
        }}
        onAccept={() => {
          handleDeceasedCheck();
        }}
        content={"Are you sure?"}
        typeDeceased={true}
        DeceasedVal={formik.values?.deceasedInput}
        subContent={`You are about to mark ${formik.values?.first_name} ${formik.values?.last_name} as deceased. Setting this contact as deceased will remove them as an observer from all associated Yahrzeits. Are you sure?`}
        childrenValue={
          <div
            style={{
              margin: "0rem 2rem",
            }}
          >
            <InputField
              {...{
                formik,
                title: "none",
                name: "deceasedInput",
                placeholder: "",
                value: formik.values?.deceasedInput,
              }}
            />
          </div>
        }
      ></MainDialog>

      <MyModal open={open} onClose={handleClose}>
        <div className="personal-info-image">
          <ImageUploader
            withIcon={false}
            withPreview={true}
            buttonText="Choose images"
            onChange={onDrop}
            accept=".png,.jpg,.jpeg"
            imgExtension={[".jpg", ".png"]}
            maxFileSize={5242880}
          />
          <div className="w-100 d-flex justify-content-center align-items-center mt-2">
            <Button onClick={handleClose} variant="primary" size="md">
              Save
            </Button>
          </div>
        </div>
      </MyModal>

      <MyModal
        className="create-yahrzeit-modal"
        open={openCreateYahrzeit}
        onClose={closeCreateYahrzeitAlert}
      >
        <CreateYahrzeitAlert
          closeModal={() => setOpenCreateYahrzeit(false)}
          user={user}
        />
      </MyModal>
      <MyModal
        className="main__alert-dialog"
        open={openAddRelatedContact}
        onClose={closeAddRelatedContactHandler}
      >
        <AddRelatedContact
          accountId={user?.account?._id}
          closeModal={closeAddRelatedContactHandler}
          AddRelatedContact={() => {}}
          formatOptionLabel
          relationshipOptions={relationshipOptions?.options}
          colourStyles={colourStyles}
          onAddRelatedContact={addRelatedContactHandler}
        />
      </MyModal>
      {isOpenMergePopUp && (
        <MergeFamilyModal
          isOpen={isOpenMergePopUp}
          handleClose={() => setConfirmClose(true)}
          closeSuccessModal={() => setIsOpenMergePopUp(false)}
          users={users}
        />
      )}

      <AlertDialog
        open={confirmDialog?.value}
        onDecline={() => {
          setConfirmDialog({ key: "", value: false });
        }}
        onAccept={() => {
          formik.setFieldValue(
            confirmDialog?.key,
            !formik.values?.[confirmDialog?.key]
          );
          setConfirmDialog({ key: "", value: false });
        }}
        title={`Are you sure?`}
        description={displaySubscribeDialogMsg(confirmDialog?.key)}
      />

      <AlertDialog
        open={confirmDeleteRelatedContact.open}
        onDecline={closeConfirmDeleteRelatedContact}
        onAccept={() => {
          deleteRelatedContactHandler(confirmDeleteRelatedContact.index);
        }}
        title={`Are you sure?`}
        description={"Do you want to delete this related contact?"}
      />
      {confirmClose && (
        <AlertDialog
          open={confirmClose}
          onDecline={() => {
            setConfirmClose(false);
          }}
          onAccept={() => {
            setConfirmClose(false);
            setIsOpenMergePopUp(false);
          }}
          title={"Are you sure?"}
          description={"Do you want to discard the changes you made?"}
        />
      )}
    </>
  );
};
export default AddNewMember;
